import { PageData, PageReq, PageReply } from '@/types/common'
import { computed, Ref, ref, ComputedRef } from 'vue'

const generateDefaultPageMeta = (): PageData => ({
  limit: 10,
  count: 0,
  page: 1,
  hasnext: false,
})

export default (
  customPageMeta?: Partial<PageData>,
): {
  pageMeta: Ref<PageData>
  pageParams: ComputedRef<{
    limit: number
    page: number
  }>
  initPageMeta: () => void
  setPageMeta: (data: PageData) => void
  toPageMeta: (preq: PageReq, preply: PageReply) => PageData
} => {
  const pageMeta: Ref<PageData> = ref({ ...generateDefaultPageMeta(), ...(customPageMeta ?? {}) })
  const pageParams = computed(() => ({
    limit: pageMeta.value.limit,
    page: pageMeta.value.page,
  }))

  const initPageMeta = () => {
    pageMeta.value = generateDefaultPageMeta()
  }

  const setPageMeta = (data: PageData) => {
    if (data.count === undefined) {
      pageMeta.value.count = -1
      pageMeta.value.hasnext = data.hasnext
    } else {
      pageMeta.value.count = data.count
    }
    pageMeta.value.page = data.page
  }

  const toPageMeta = (preq: PageReq, preply: PageReply) => {
    return {
      count: Number(preply.total_rows),
      page: preq.page,
      limit: preq.limit,
      hasnext: preply.total_rows > preq.page * preq.limit ? true : false,
    }
  }

  return {
    pageMeta,
    pageParams,
    initPageMeta,
    setPageMeta,
    toPageMeta,
  }
}
